// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// versions:
//   protoc-gen-ts_proto  v1.181.2
//   protoc               v3.17.3
// source: squareup/connect/v2/common/coordinates.proto
/* eslint-disable */
import _m0 from "protobufjs/minimal";
export const protobufPackage = "squareup.connect.v2.common";
function createBaseCoordinates() {
    return { $type: "squareup.connect.v2.common.Coordinates", latitude: undefined, longitude: undefined };
}
export const Coordinates = {
    $type: "squareup.connect.v2.common.Coordinates",
    encode(message, writer = _m0.Writer.create()) {
        if (message.latitude !== undefined) {
            writer.uint32(9).double(message.latitude);
        }
        if (message.longitude !== undefined) {
            writer.uint32(17).double(message.longitude);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseCoordinates();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 9) {
                        break;
                    }
                    message.latitude = reader.double();
                    continue;
                case 2:
                    if (tag !== 17) {
                        break;
                    }
                    message.longitude = reader.double();
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    create(base) {
        return Coordinates.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseCoordinates();
        message.latitude = object.latitude ?? undefined;
        message.longitude = object.longitude ?? undefined;
        return message;
    },
};
